//components
import YoutubeApi from '../components/youtube-api';
import VideoHTML from '../components/video-html';
import VideoPlayer from '../components/video-player';
import DrawerItem from '../components/drawer-item';
import Header from '../components/header';
import ScrollToCta from '../components/scrollto-cta';
import PrivateLabel from '../components/private-label';
import Brand from '../components/brand';
import Share from '../components/share';
import FilterGoogleMap from '../components/filter-google-map';

const components = {
	'youtubeApi' : YoutubeApi,
	'videoHtml' : VideoHTML,
	'videoPlayer' : VideoPlayer,
	'drawerItem' : DrawerItem,
	'header' : Header,
	'scrollToCta' : ScrollToCta,
	'privateLabel' : PrivateLabel,
	'filterGoogleMap' : FilterGoogleMap,
	'brand' : Brand,
	'share' : Share,
};

class Components {

	constructor(params) {
		// Init variables
		if(params !== undefined) this.params = params; 
		this.$cache = {};
		this.instances = [];

		// Trigger init functions
		this.initCache();
		this.init();
	}

	/******************************/
	/* Init functions             */
	/******************************/
	initCache() {
		this.$cache.body = $('body');
		this.$cache.components = this.$cache.body.find('[data-component]');
	}

	resize() {
		$.each(this.instances, function() {
			let comp = this;
			let cond = (typeof comp.resize === 'function');
			if(cond) comp.resize();
		});
	}

	init(){
		this.$cache.components.each((index, element) => {
			let $el = $(element);
			let comp = $el.data('component');
          
			//Check if component exist
			if(typeof components[comp] !== 'function') return;
          
			// Component instantiation
			let obj = new components[comp]({target : $el});

			// Store instance in data
			$el.data('comp', obj);
			this.instances.push(obj);

			//Init Animation
			if(typeof obj.initScrollAnim === 'function') {
				setTimeout(() =>{ obj.initScrollAnim(); }, 150);
			}
        });
	}
}

export default Components;


// WEBPACK FOOTER //
// ./scripts/modules/Components.js